import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Language } from '../language/language.types';

import { InternalTranslationService } from './internal-translation.service';
import { NgxTranslationData, TranslationData, TranslationParameter } from './translation.types';

/**
 * This service primary exists to make angularJS migration smoother.
 *
 * For new project, please consider use of standard solution like ngx-translate together with {@link LanguageService}
 * to get the initial language.
 *
 * Initial language can be customized, see {@link LanguageService}.
 * @see LanguageService
 */
@Injectable({ providedIn: 'root' })
export class TranslationService {
    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(private translationServiceImpl: InternalTranslationService) {}

    addTranslation(translations: TranslationData): void {
        this.translationServiceImpl.addTranslation(translations);
    }

    setTranslations(translationData: Partial<Record<Language, NgxTranslationData>>): void {
        this.translationServiceImpl.setTranslations(translationData);
    }

    /**
     *
     * @deprecated use setTranslations instead to update translations atomically. Otherwise this might cause issues when consumers do not properly subscribe to the observable (e.g. use take(1))
     * @param languageKey
     * @param translation
     */
    setTranslation(languageKey: Language, translation: NgxTranslationData): void {
        this.translationServiceImpl.setTranslation(languageKey, translation);
    }

    translate(key: string, interpolateParams?: TranslationParameter): Observable<string> {
        return this.translationServiceImpl.translate(key, interpolateParams);
    }

    /**
     * @deprecated use LanguageService.language$
     */
    getLanguage(): Observable<Language> {
        return this.translationServiceImpl.getLanguage();
    }

    /**
     * @deprecated use LanguageService.use()
     */
    setLanguage(language: Language): void {
        return this.translationServiceImpl.use(language);
    }

    translateTo(lang: Language, key: string, interpolateParams?: TranslationParameter): Observable<string> {
        return this.translationServiceImpl.translateTo(lang, key, interpolateParams);
    }

    hasTranslation(key: string, lang?: Language): Observable<boolean> {
        return this.translationServiceImpl.hasTranslation(key, lang);
    }
}
